import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbSchema = ({ trail }) => {
  if (!trail || !trail.length || typeof window === 'undefined') {
    return null;
  }

  const origin = window.location.origin;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail
      .filter(item => item.url)
      .map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.label,
        item: `${origin}${item.url}`,
      })),
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
};

BreadcrumbSchema.propTypes = {
  trail: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default BreadcrumbSchema;
